<template>
  <v-dialog
    v-model="dialog"
    max-width="400px"
    persistent
    @keydown.esc="onDialogClose"
    hide-overlay
  >
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialogUpdateItem" persistent max-width="300px" hide-overlay>
      <v-row no-gutters>
        <v-col>
          <v-card color="white" flat tile>
            <v-card-title class="dialog-header-title px-1">{{
              dialogUpdateTitle
            }}</v-card-title>

            <v-card-text>
              <v-row>
                <v-col>
                  <span>Tonnage size:</span>
                  <input
                    type="number"
                    class="form-control"
                    :disabled="disableOnUpdate"
                    v-model="tonnage_obj.tonnage_size"
                  />
                </v-col>

                <v-col>
                  <span>Max. CBM:</span>
                  <input class="form-control" v-model="tonnage_obj.max_cbm" />
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-row justify="end">
                <v-btn
                  @click="saveTonnageItem"
                  class="font-weight-bold mr-2"
                  color="primary"
                  tile
                  depressed
                  small
                  >SAVE</v-btn
                >
                <v-btn
                  @click="dialogUpdateItem = false"
                  small
                  class="font-weight-bold ml-2"
                  color="error"
                  tile
                  depressed
                  >CLOSE</v-btn
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>

    <v-card flat color="white" tile>
      <v-card-title class="dialog-header-title px-1"
        >Transport tonnage sizes</v-card-title
      >

      <v-card-text class="pa-1">
        <v-row>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                icon
                color="primary"
                class="mx-0"
                @click="onNewTonnageItem"
              >
                <v-icon>mdi-plus-box</v-icon>
              </v-btn>
            </template>
            Add new tonnage item
          </v-tooltip>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card flat tile color="white">
              <v-data-table
                dense
                :items="tonnages"
                :headers="headers"
                item-key="ton"
                hide-default-footer
              >
                <template v-slot:item="{ item }">
                  <tr :key="item.ton">
                    <td class="service-table-cell">{{ item.tonnage_size }}</td>
                    <td class="service-table-cell">{{ item.max_cbm }}</td>
                    <td class="justify-center px-0">
                      <v-menu bottom origin="center center" transition="scale-transition">
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" color="primary" text icon small>
                            <v-icon>menu</v-icon>
                          </v-btn>
                        </template>

                        <v-list dense>
                          <v-list-item
                            v-for="(el, i) in menuOptions"
                            :key="i"
                            @click="onMenu(i, item)"
                          >
                            <v-list-item-action class="mr-2">
                              <v-icon size="20" :color="el.color">{{ el.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>{{ el.title }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-row justify="end">
          <v-btn
            color="error"
            class="font-weight-bold"
            depressed
            tile
            small
            @click="onDialogClose"
            >CLOSE</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import constant from "@/const";
export default {
  props: ["dialog"],
  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,

      tonnages: [],

      tonnage_obj: {
        ton: null,
        tonnage_size: 0.0,
        max_cbm: 0.0,
      },
      sync_tonnage_obj: {},

      dialogUpdateItem: false,
      disableOnUpdate: false,
      dialogUpdateTitle: "Add new transport tonnage",

      headers: [
        { text: "Tonnage size", value: "ton", align: "center" },
        {
          text: "Max. CBM",
          value: "max_cbm",
          align: "center",
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ],

      menuOptions: [
        { title: "Update", icon: "mdi-pencil", color: "primary" },
        { title: "Delete", icon: "mdi-delete", color: "error" },
      ],
    };
  },

  watch: {
    dialog() {
      if (this.dialog) {
        // initialise tonnage obj
        this.init();
        // load the tonnage list
        this.loadTonnageList();
      } else {
        this.tonnages = [];
      }
    },
  },

  methods: {
    /**
     * Init
     */
    init() {
      this.tonnage_obj = {
        ton: null,
        tonnage_size: 0.0,
        max_cbm: 0.0,
      };
    },

    /**
     * Get tonnage list
     */
    async loadTonnageList() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;
      var resp = await this.$https.get("/api/pts/transport_tonnage");
      this.tonnages = resp.data.data || [];
      this.$root.blockUIshow = false;
    },

    onMenu(index, item) {
      switch (index) {
        case 0:
          this.onUpdateTonnageItem(item);
          break;
        case 1:
          this.onDeleteTonnage(item);
          break;
      }
    },

    /**
     * onNewTonnageItem
     */
    onNewTonnageItem() {
      this.tonnage_obj = {
        ton: null,
        tonnage_size: 0.0,
        max_cbm: 0.0,
      };
      // update the title header
      this.dialogUpdateTitle = "Add new transport tonnage";
      this.disableOnUpdate = false;
      this.dialogUpdateItem = true;
    },

    /**
     * Open update Item dialog
     */
    async onUpdateTonnageItem(item) {
      this.$root.blockUImsg = "loading...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(`/api/pts/transport_tonnage/${item.ton}`);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.tonnage_obj = resp.data.data;
        this.sync_tonnage_obj = item;
        // update the title header
        this.dialogUpdateTitle = "Update transport tonnage";

        // disable the tonnage size input field
        this.disableOnUpdate = true;

        // open dialog update item
        this.dialogUpdateItem = true;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }
      this.$root.blockUIshow = false;
    },

    /**
     * save tonnage item
     */
    async saveTonnageItem() {
      this.$root.blockUImsg = "loading...";
      this.$root.blockUIshow = true;

      // if ton is null, then create
      if (this.tonnage_obj.ton == null) {
        // ton is the id representation
        let resp = await this.$https.post(`/api/pts/transport_tonnage`, this.tonnage_obj);
        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = resp.data.msg;
          // close dialog update item
          this.dialogUpdateItem = false;

          // refresh list
          this.tonnages.push(resp.data.data);
          this.init();
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
      } else {
        let resp = await this.$https.put(
          `/api/pts/transport_tonnage/${this.tonnage_obj.ton}`,
          this.tonnage_obj
        );
        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = resp.data.msg;
          // close dialog update item
          this.dialogUpdateItem = false;

          // refresh list
          this.sync_tonnage_obj = Object.assign(this.sync_tonnage_obj, resp.data.data);
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
      }

      this.$root.blockUIshow = false;
    },

    /**
     * Delete currency conversion
     * @param {object} item
     */
    async onDeleteTonnage(item) {
      // confirm deletion
      let confirmation = confirm("Are you sure you want to delete this tonnage item?");

      if (confirmation) {
        this.$root.msg = "deleting tonnage item...";
        this.$root.blockUIshow = true;

        let resp = await this.$https.delete(`/api/pts/transport_tonnage/${item.ton}`);
        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = resp.data.msg;
          // refresh list
          this.tonnages = this.tonnages.filter((tonnageItem) => {
            return tonnageItem != item;
          });
        } else {
          console.log(resp.data);
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
      }

      this.$root.blockUIshow = false;
    },

    /**
     * Close dialog
     */
    onDialogClose() {
      this.$emit("dialog-close");
    },
  },
};
</script>

<style scoped></style>
